export class DateUtilities {
  private static dateWithTime = new Intl.DateTimeFormat("fr-BE", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  private static dateWithTimeFull = new Intl.DateTimeFormat("fr-BE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  private static intlDateFormat = new Intl.DateTimeFormat("fr-BE");

  public static display(date: Date | string | null): string {
    if (date === null) {
      return "";
    }
    if (typeof date === "string") {
      if (date.includes("00") && !date.includes("T")) {
        return date
          .split("-")
          .sort((a: string, b: string) => a.length - b.length)
          .join("/");
      }
      date = new Date(date);
    }
    return DateUtilities.intlDateFormat.format(date as Date);
  }

  public static formatWithTime(date: string): string {
    return DateUtilities.dateWithTime.format(new Date(date));
  }

  public static formatWithTimeFull(date: string): string {
    return DateUtilities.dateWithTimeFull.format(new Date(date));
  }

  private static getLocaleDate(
    date: Date
  ): {
    year: string;
    month: string;
    day: string;
    hours: string;
    minutes: string;
    seconds: string;
  } {
    const getTimeUnitValue = (dateMethod: "getFullYear" | "getDate" | "getHours" | "getMinutes" | "getSeconds") =>
      String(date[dateMethod]()).padStart(2, "0");
    return {
      year: getTimeUnitValue("getFullYear"),
      month: String(date.getMonth() + 1).padStart(2, "0"),
      day: getTimeUnitValue("getDate"),
      hours: getTimeUnitValue("getHours"),
      minutes: getTimeUnitValue("getMinutes"),
      seconds: getTimeUnitValue("getSeconds"),
    };
  }

  public static getLocaleISOString({
    date = new Date(),
    format = "YYYY-MM-DD",
  }: { date?: Date; format?: "YYYY-MM-DD" | "YYYY-MM-DDTHH:mm:ss" } = {}) {
    const { year, month, day, hours, minutes, seconds } = this.getLocaleDate(date);
    return format
      .replace("YYYY", year)
      .replace("MM", month)
      .replace("DD", day)
      .replace("HH", hours)
      .replace("mm", minutes)
      .replace("ss", seconds);
  }

  public static getTimestamp({ date = new Date(), locale }: { date?: Date; locale?: boolean } = {}) {
    const { year, month, day, hours, minutes, seconds } = this.getLocaleDate(date);
    const isoDate = date
      .toISOString()
      .slice(0, -5)
      .replaceAll(/-*T*:*/g, "");
    return locale ? `${year}${month}${day}${hours}${minutes}${seconds}` : isoDate;
  }
}
